import {useTranslation} from 'react-i18next'
import type {components} from '@/lib/api-schema'

type PerfilAlcance = components['schemas']['AlcancePerfilRead']

/** Lo que nace y lo que deja de exigirse, antes de firmar (§9); lo retirado se nombra, no se cuenta. */
export function AlcanceRequisitos({alcance}: {alcance: PerfilAlcance}) {
  const {t} = useTranslation()
  return (
    <p className="text-sm text-muted-foreground" data-testid="alcance-requisitos">
      {t('perfilCargo.alcance.nacen', {count: alcance.requisitos_nacen})}{' '}
      {alcance.requisitos_mueren.length === 0
        ? t('perfilCargo.alcance.sinMueren')
        : t('perfilCargo.alcance.mueren', {
            count: alcance.requisitos_mueren.length,
            nombres: alcance.requisitos_mueren.map((requisito) => requisito.nombre).join(', '),
          })}
    </p>
  )
}
